import { useState } from 'react'

import { isChargebackError } from './helpers'

const useChargebackErrorModal = () => {
  const [showChargebackModal, setShowChargebackModal] = useState(false)

  const closeChargebackModal = () => {
    setShowChargebackModal(false)
  }

  const handleChargebackError = err => {
    if (isChargebackError(err)) {
      setShowChargebackModal(true)
      return true
    }
    return false
  }

  return {
    showChargebackModal,
    closeChargebackModal,
    handleChargebackError,
  }
}

export default useChargebackErrorModal
